import TextLinkButton from "components/buttons/TextLinkButton";
import OptionalTextInput from "components/ValidatedFields/OptionalTextInput";
import React from "react";
import { Button } from "semantic-ui-react";
import * as Sentry from "@sentry/browser";

interface Props {
  initialText: string
  onSave: (newText: string) => Promise<boolean>
  maxLength: number
}

const EditableText = (props: Props) => {
  const [isEditing, setIsEditing] = React.useState(!props.initialText);
  const [editedText, setEditedText] = React.useState(props.initialText);
  const [textHasError, setTextHasError] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);

  const trySave: React.FormEventHandler<HTMLFormElement> = async (e) => {
    e.preventDefault();

    const hasValue = editedText.trim().length > 0;
    setTextHasError(!hasValue);
    if (!hasValue) {
      return;
    }

    setIsLoading(true);

    try {
      const hasSucceeded = await props.onSave(editedText);
      if (hasSucceeded) {
        setIsEditing(false);
      } else {
        setTextHasError(true);
      }
    } catch (e) {
      Sentry.captureException(e);
    } finally {
      setIsLoading(false);
    }
  };

  if (isEditing) {
    return <form className="flex" onSubmit={trySave}>
      <div className="grow1 margin-right">
        <OptionalTextInput
          hasError={textHasError}
          value={editedText}
          onChange={setEditedText}
          maxLength={props.maxLength}
        />
      </div>
      <div>
        <Button primary disabled={isLoading} loading={isLoading} type="submit">
          {RESX.Buttons.btnSave}
        </Button>
      </div>
    </form>;
  }

  return <TextLinkButton
    onClick={() => { setIsEditing(true); }}
    style={{ padding: 0 }} >
    {editedText}
  </TextLinkButton>;
};

export default EditableText;